import React, { useState } from "react";

import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../context/StateContext";
import { WidgetProps } from "../../../../models/shipment.tracking";
import DashboardService from "../../../../services/dashboard.service";
import { formatThousandsWithComma } from "../../../../util/formatThousandsWithComma";
import { useStyles } from "./styles";

/** Default Functional Component */
export default function TotalContainers({ widgetFilter }: WidgetProps) {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [total, setTotal] = useState<number>(0);

  useQuery(
    ["dashboard.container.total.count", widgetFilter],
    () =>
      DashboardService.getTotalContainerCount({
        dateFrom: widgetFilter?.dateFrom,
        dateTo: widgetFilter?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response?.data !== undefined && !Number.isNaN(Number(response?.data))) {
          setTotal(response?.data);
        }
      },
      enabled: !!currentUser?.companyId,
    }
  );

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} gutterBottom data-cy="totalContainersTitle">
        {translate("totalContainers")}
      </Typography>

      <Typography
        className={classes.lblFigures}
        variant="h5"
        component="h2"
        align="left"
        data-cy="totalContainers"
      >
        {formatThousandsWithComma(String(total))}
      </Typography>
    </Box>
  );
}
